<template>
    <div v-if="isVisible" :id="type">
        <p class="headline mb-0 text-uppercase">{{ title | translation }}</p>
        <hr class="underline mb-2" />
        <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-layout row wrap class="px-2">
                <template v-for="(product, index) in buyableProducts">
                    <v-flex :key="`related-product${product.id}`" xs12 md6 d-flex class="pa-3">
                        <related-products-thumbnail :product="product" />
                    </v-flex>

                    <v-flex xs12 v-if="index % 2 === 1" class="px-0" :key="`related-product-divider-${product.id}`">
                        <hr class="underline gray" />
                    </v-flex>
                </template>
            </v-layout>
        </template>

        <template v-else>
            <v-flex xs12 class="mb-1">
                <v-window v-model="page">
                    <v-item v-for="product in buyableProducts" :key="`related-product-card-${product.id}`">
                        <v-window-item>
                            <related-products-thumbnail :product="product" />
                        </v-window-item>
                    </v-item>
                </v-window>
            </v-flex>
            <hr class="underline gray" />
            <v-flex xs12 class="align-center justify-center">
                <v-item-group v-model="page" class="text-xs-center" mandatory>
                    <v-item v-for="product in buyableProducts" :key="`related-product-btn-${product.id}`">
                        <v-btn
                            slot-scope="{ active, toggle }"
                            :input-value="active"
                            active-class="active-page-button"
                            icon
                            small
                            @click="toggle"
                            class="page-button ma-0"
                        >
                            <v-icon
                                :size="active ? 16 : 12"
                                color="dark lighten-6"
                                v-text="active ? 'fiber_manual_record' : 'trip_origin'"
                            />
                        </v-btn>
                    </v-item>
                </v-item-group>
            </v-flex>
        </template>
        <div class="pb-5"></div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { Observable } from 'rxjs';
import { getProducts } from '../store/getProducts';

const parentModuleName = 'Product';
const { mapGetters, mapState, mapActions, mapMutations } = createNamespacedHelpers(parentModuleName);

export default {
    name: 'RelatedProducts',
    props: ['type'],
    data() {
        return {
            titles: {
                upsells: 'Dazu passende Produkte',
                crosssells: 'Diese Produkte könnten Sie auch noch interessieren',
            },
            products: [],
            productsSubscriber: null,
            page: 0,
        };
    },
    computed: {
        title: function() {
            return this.titles[this.type];
        },
        isVisible() {
            return this.buyableProducts.length > 0;
        },
        getSellsIds() {
            let result = [];
            let product = this.getProduct();
            if (product && product[this.type] && product[this.type].length > 0) {
                result = product[this.type];
            }
            return result;
        },
        buyableProducts() {
            if (this.products && this.products.length) {
                return this.products.filter(product => {
                    let merchantID = '';
                    const merchants = Object.values(product.merchant);
                    for (const merchant of merchants) {
                        merchantID = merchant.id;
                        break;
                    }
                    return product.price && product.price.price > 0 && product.merchant[merchantID].price[product.id];
                });
            }
            return [];
        },
    },
    created() {
        this.productsSubscriber = getProducts(
            new Observable(subscriber =>
                this.$watch(
                    'getSellsIds',
                    ids =>
                        subscriber.next({
                            ids,
                        }),
                    {
                        immediate: true,
                    },
                ),
            ),
        ).subscribe(products => (this.products = products));
    },
    beforeDestroy() {
        this.productsSubscriber.unsubscribe();
    },
    methods: {
        ...mapGetters(['getProduct', 'currentProductId']),
    },
};
</script>

<style lang="stylus" scoped>
hr.underline {
    &.gray {
        border: 0px solid #c3c3c3;
        border-bottom-width: 1px;
    }
    width: 100%;
    margin: 0;
    padding: 0;
}
.page-button {
    color: #a5a5a5;
    width: 20px !important;
    height: 20px !important;
}
</style>
